/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';


/**
 * ThirdPartyCalloutService provides integration callout related functionalities
 *
 * @module enervee_utils.third_party_integrations
 */
ThirdPartyCalloutService.$inject = [
    'UtilService',
];
function ThirdPartyCalloutService(
    UtilService,
) {

    return {
        injectCallouts: injectCallouts
    };

    /**
     * Injects the third party callouts into the results list.
     *
     * @param activeCategory {Object} the active category object
     * @param pageNumber {int} the number of the current page
     * @param productsPerPage {int} the max number of products per page
     * @param results {Array} the results array of products
     * @param calloutListIndex {int} the index of the position to place the callout for old filters
     */
    function injectCallouts(activeCategory, pageNumber, productsPerPage, results, calloutListIndex) {
        const isNewFiltersEnabled = UtilService.isFeatureEnabled("new_filters_enabled");
        if (!isNewFiltersEnabled || UtilService.isMobile()) {
            results.splice(calloutListIndex, 0, {'card_type': 'third_party_integration'});
            return;
        }

        const integrationsSetting = UtilService.getCategoryOrSiteSetting(
            activeCategory.id,
            'third_party_integrations',
            []
        );

        // Calculating the index number of the first product in the page as well as the maximum number of products
        // and the index where the last callout will be positioned at.
        const calloutFrequency = 5;
        const firstProductIndexInPage = ((pageNumber - 1) * productsPerPage) + 1;
        const maxProductIndex = pageNumber * productsPerPage;
        const maxCalloutIndex = integrationsSetting.length * calloutFrequency;

        if (maxCalloutIndex > firstProductIndexInPage) {
            let currentCalloutSettingIndex = Math.ceil(firstProductIndexInPage / calloutFrequency) - 1;
            let currentCalloutIndex = ((currentCalloutSettingIndex + 1) * calloutFrequency) - 1;

            // calculates the current callout index and inserts it into the result's array
            for (currentCalloutSettingIndex; currentCalloutIndex <= maxProductIndex; currentCalloutSettingIndex++) {
                if (typeof integrationsSetting[currentCalloutSettingIndex] === 'undefined') {
                    break;
                }
                const callout = integrationsSetting[currentCalloutSettingIndex];
                let calloutLink = null;
                let calloutCode = null;
                if (callout.hasOwnProperty('code')) {
                    calloutLink = callout['link'];
                    calloutCode = callout['code'];
                } else {
                    calloutCode = callout;
                }

                currentCalloutIndex = ((currentCalloutSettingIndex + 1) * calloutFrequency) - 1;

                if (currentCalloutIndex > (maxProductIndex + currentCalloutSettingIndex)) {
                    break;
                }

                results.splice(currentCalloutIndex, 0, {
                    'card_type': 'third_party_callout',
                    'integration_callout_code': calloutCode,
                    'integration_callout_link': calloutLink
                });
            }
        }
    }

}

module.exports = ThirdPartyCalloutService;